export default {
  models: [],
  menuSelected: ''
}
